module.exports = __webpack_public_path__ + "55287aef9dd06c9d7c4ab31aab4d920f.pdf";